module.exports = __webpack_public_path__ + "static/media/no-jobs-jobs-employer.675a34b3.svg";